import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, Platform, Events } from 'ionic-angular';
import { expandVertical } from '../../../../animations/appear-animation';
import { ProfileBloc } from '../../../../bloc/feature/profile/profile.bloc';
import { AppVersion } from '@ionic-native/app-version';
import { AppPreferences } from '../../../../shared/local/app-preferences.local';

export enum ResponseModalSingout {
  LOGOUT = 'LOGOUT',
  SUPPORT = 'SUPPORT',
  SETTING = 'SETTING',
  PROFILE = 'PROFILE'
}

@IonicPage()
@Component({
  selector: 'page-modal-singout',
  templateUrl: 'modal-singout.html',
  animations: [expandVertical]
})
export class ModalSingoutPage {

  public multiAccount: boolean = false;
  public versionNumber = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public profileBloc: ProfileBloc,
    public viewCtrl: ViewController,
    public appVersion: AppVersion,
    public platform: Platform,
    public events: Events,
    public appPreferences: AppPreferences
  ) {
  }

  async ionViewDidLoad() {
    if (this.platform.is('cordova')) {
      this.versionNumber = await this.appVersion.getVersionNumber();
    }
    localStorage.setItem('guide-tabs', '1');
    this.eventListener();
  }

  openMultiAcc() {
    this.multiAccount = !this.multiAccount;
  }

  dismiss(data?: ResponseModalSingout) {
    this.viewCtrl.dismiss(data)
  }

  eventListener() {
    this.events.unsubscribe('multiaccount:switchdone');
    this.events.subscribe('multiaccount:switchdone', () => {
      this.dismiss();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/home-tabs/home/modal-singout/modal-singout.ts